// extracted by mini-css-extract-plugin
export default {"breadcrumb":"nj-z","breadcrumbItem":"oj-z","hideOnMobile":"pj-z"};